<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>To the vast indigo heights of the Andromeda galaxy, Eos the Dawn Goddess, I do dedicate my work, who takes full care of her subjects within the surrounding systems as Eos be-speckles her heavenly jewels upon Andromeda, while she slowly rotates and sparkles the differing systems in their shimmering hues, across her gateway to Orion.</p>
<br/>
<p style="text-indent:00em;">Prime Minister Margaret Thatcher doing her Prime Minister’s Questions at her dispatch box in the House of Commons, London.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?886c4c12